export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] py-16 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-home-heart-line text-2xl text-[#FF6B35]"></i>
              </div>
              <span className="text-lg font-semibold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
                ContentKit
              </span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs mb-6">
              Professional Instagram content templates for modern real estate agents. Post consistently, grow your brand, close more deals.
            </p>
            <div className="flex items-center gap-4">
              {[
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-facebook-circle-line', href: '#' },
                { icon: 'ri-twitter-x-line', href: '#' },
                { icon: 'ri-linkedin-box-line', href: '#' },
              ].map((social) => (
                <a
                  key={social.icon}
                  href={social.href}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-gray-400 hover:bg-[#FF6B35] hover:text-white transition-all cursor-pointer"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-xs font-bold text-white mb-5 uppercase tracking-widest">Product</h4>
            <ul className="space-y-3">
              {['Templates', 'Features', 'Pricing', 'How It Works'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-xs font-bold text-white mb-5 uppercase tracking-widest">Support</h4>
            <ul className="space-y-3">
              {['FAQ', 'Contact Us', 'Tutorials', 'Refund Policy'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex items-center justify-between">
          <p className="text-xs text-gray-500">
            © 2025 ContentKit. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-gray-500 hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-xs text-gray-500 hover:text-white transition-colors cursor-pointer">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
